import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { Zellige } from "../components/Zellige";
import { menuSections, menuNotes } from "../config/menu";
import { site } from "../config/site";

export default function Carte() {
  const menuJsonLd = {
    "@context": "https://schema.org",
    "@type": "Menu",
    "name": "Carte TN FOOD",
    "hasMenuSection": menuSections.map((s) => ({
      "@type": "MenuSection",
      "name": s.title,
      "hasMenuItem": s.items.map((i) => ({
        "@type": "MenuItem",
        "name": i.name,
        "description": i.description || i.name,
      })),
    })),
  };

  return (
    <main id="contenu-principal">
      <Seo
        title="Notre carte — Spécialités tunisiennes | TN FOOD"
        description="Découvrez la carte TN FOOD : briks, salades tunisiennes, couscous, tajines, grillades, pâtisseries orientales et thé à la menthe. Prix TTC, service compris. Sainte-Savine, près de Troyes."
        path="/carte"
        jsonLd={menuJsonLd}
      />

      <section className="bg-bordeaux text-cream py-16 md:py-20">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <Reveal>
            <h1 className="font-display text-4xl md:text-5xl font-bold">Notre carte</h1>
            <p className="mt-4 text-lg text-cream/85 max-w-2xl">
              Des spécialités tunisiennes préparées sur place, avec des produits frais et des épices authentiques. Prix TTC, service compris.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative py-16 md:py-24 overflow-hidden" data-testid="carte-sections">
        <Zellige />
        <div className="relative container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl space-y-16">
          {menuSections.map((section) => (
            <Reveal key={section.id}>
              <section aria-labelledby={`carte-${section.id}`} data-testid={`carte-section-${section.id}`}>
                <h2 id={`carte-${section.id}`} className="font-display text-3xl font-semibold text-encre border-b-2 border-terracotta/30 pb-3">
                  {section.title}
                </h2>
                <ul className="mt-6 grid md:grid-cols-2 gap-x-10 gap-y-6">
                  {section.items.map((item) => (
                    <li key={item.name} className="flex flex-col">
                      <div className="flex items-baseline gap-2">
                        <h3 className="font-semibold text-encre">{item.name}</h3>
                        <span className="flex-1 border-b border-dotted border-taupe/40 translate-y-[-4px]" aria-hidden="true" />
                        <span className="font-bold text-terracotta whitespace-nowrap">{item.price}</span>
                      </div>
                      {item.description && <p className="mt-1 text-sm text-taupe leading-relaxed">{item.description}</p>}
                    </li>
                  ))}
                </ul>
              </section>
            </Reveal>
          ))}

          <Reveal>
            <div className="bg-cream border border-gold/40 rounded-2xl p-6 md:p-8" data-testid="carte-allergenes">
              <p className="flex gap-3 text-taupe leading-relaxed">
                <AlertCircle className="h-5 w-5 mt-0.5 shrink-0 text-saffron" strokeWidth={1.5} />
                <span>{menuNotes.allergens}</span>
              </p>
              <p className="mt-3 text-sm text-taupe">{menuNotes.tva}</p>
            </div>
            <div className="mt-10 text-center">
              <Link to="/contact#reservation" data-testid="carte-cta-reserver" className="inline-block rounded-full bg-terracotta text-cream px-8 py-3.5 font-semibold transition-all duration-300 hover:bg-terracotta-dark hover:-translate-y-0.5">
                Réserver une table
              </Link>
              <p className="mt-4 text-sm text-taupe">
                Ou appelez-nous au <a href={site.phoneHref} className="text-terracotta font-semibold hover:underline">{site.phone}</a>
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
